/**
 * 첫 방문 세션 판별 — 처음 온 방문자에게 진입 직후 팝업을 띄우지 않기 위해 쓴다.
 * - 이 브라우저에서 처음 본 순간 localStorage에 시각을 남기고, 그 탭 세션을 "첫 세션"으로 표시한다.
 * - 같은 세션 안에서는 페이지를 옮겨도 첫 세션으로 유지되고, 다음 방문(새 세션)부터 재방문으로 본다.
 * - 저장소를 쓸 수 없는 환경(사파리 비공개 모드 등)은 첫 세션으로 본다. 팝업을 못 보는 쪽이 안전하다.
 */
export const FIRST_SEEN_STORAGE_KEY = 'whatquiz_first_seen_at';
export const FIRST_SESSION_STORAGE_KEY = 'whatquiz_first_session';

export const isFirstVisitSession = () => {
  if (typeof window === 'undefined') return true;
  try {
    if (window.sessionStorage.getItem(FIRST_SESSION_STORAGE_KEY) === '1') return true;
    if (window.localStorage.getItem(FIRST_SEEN_STORAGE_KEY)) return false;
    window.localStorage.setItem(FIRST_SEEN_STORAGE_KEY, new Date().toISOString());
    window.sessionStorage.setItem(FIRST_SESSION_STORAGE_KEY, '1');
    return true;
  } catch {
    return true;
  }
};
